import React, { forwardRef } from 'react';
import { OptionBase, OptionBaseProps } from '../base/OptionBase';

export type CheckboxProps = OptionBaseProps;

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  (
    {
      label,
      id,
      checked,
      defaultChecked,
      disabled,
      value,
      onChange,
      onBlur,
      name,
      invalid,
      required,
      onFocus,
      errorMessage,
      ...rest
    },
    ref
  ) => (
    <OptionBase
      type="checkbox"
      label={label}
      id={id}
      checked={checked}
      defaultChecked={defaultChecked}
      disabled={disabled}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      name={name}
      required={required}
      invalid={invalid}
      onFocus={onFocus}
      ref={ref}
      errorMessage={errorMessage}
      {...rest}
    />
  )
);

Checkbox.displayName = 'Checkbox';
